<template>
  <a-modal
    :title="isEdit ? '修改新闻资讯' : '发布新闻资讯'"
    :visible="visible"
    :confirmLoading="submitting"
    destroyOnClose
    okText="提交"
    cancelText="取消"
    width="1150px"
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="$emit('update:visible', false)"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-form-item label="封面图" v-bind="formItemLayout">
          <picture-card :max="1" :fileList.sync="imgList"/>
        </a-form-item>
        <a-form-item label="标题" v-bind="formItemLayout">
          <a-input
            placeholder="请输入标题"
            v-decorator="['title', {
              validateFirst: true,
              normalize: trimNormalizer,
              rules: [
                { required: true, message: '请输入标题' },
                { max: 32, message: '最多只能输入32个字符' }
              ]
            }]"
          />
        </a-form-item>
        <a-form-item label="通知类型" v-bind="formItemLayout">
          <a-select
            placeholder="请选择通知类型"
            v-decorator="['type', {
              rules: [{ required: true, message: '请选择字典类型'}]
            }]"
          >
            <a-select-option value="3">园区通知</a-select-option>
            <a-select-option value="4">园区新闻</a-select-option>
            <a-select-option value="5">园区资讯</a-select-option>
            <a-select-option value="6">园区政策</a-select-option>
            <a-select-option value="7">园区党建</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" v-bind="formItemLayout">
          <a-switch
            checkedChildren="发布"
            unCheckedChildren="下架"
            v-decorator="['state', {
            initialValue: true,
            valuePropName: 'checked'
          }]"
          />
        </a-form-item>
        <a-form-item label="详情" v-bind="formItemLayout">
          <div ref="editor"></div>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { notice, common } from '@/api'
import { trimNormalizer } from '@/utils/tools'
import pick from 'lodash/pick'
import E from 'wangeditor'
export default {
  name: 'DialogNoticeNews',

  props: {
    visible: Boolean,
    current: Object
  },

  beforeCreate () {
    this.formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 }
    }
  },

  computed: {
    isEdit () {
      return Boolean(Object.keys(this.current).length !== 0)
    }
  },
  watch: {
    async visible (newVal) {
      await this.$nextTick()
      if (newVal && this.isEdit) {
        this.form.setFieldsValue(pick(this.current, ['title', 'type', 'state']))
        this.imgList = this.current.img ? [this.current.img] : []
      } else {
        this.imgList = []
      }
      this.content = this.current.content ? this.current.content : ''
      this.editorInit()
    }
  },
  mounted () {
  },

  data () {
    return {
      loading: false,
      submitting: false,
      trimNormalizer,
      imgList: [],
      form: this.$form.createForm(this),
      content: ''
    }
  },

  methods: {
    editorInit () {
      let editor = new E(this.$refs.editor)
      editor.customConfig = {
        onchange: html => {
          this.content = html
        },
        uploadImgServer: `${process.env.VUE_APP_API}${common.uploadSingle}`, // 上传图片到服务器
        uploadFileName: 'file', // 后端使用这个字段获取图片信息
        uploadImgMaxLength: 1, // 限制一次最多上传 1 张图片
        uploadImgMaxSize: 3 * 1024 * 1024,
        uploadImgTimeout: 50000
      }
      editor.customConfig.uploadImgHooks = {
        before: function (xhr, editor, files) {
          let formdata = new FormData()
          formdata.append('file', files)
        },
        customInsert: function (insertImg, result, editor) {
          insertImg(process.env.VUE_APP_IMG + result.data)
        }
      }
      editor.create()
      if (this.content) {
        editor.txt.html(this.content)
      }
    },
    handleSubmit () {
      if (this.loading) return
      this.form.validateFields(async (err, values) => {
        if (err) return
        if (this.imgList.length === 0) return this.$message.warn('请上传封面图！')
        if (!this.content) return this.$message.warn('请填写新闻资讯详情！')
        let payload = {
          ...values,
          content: this.content,
          img: this.imgList.length ? this.imgList.map(x => typeof x === 'string' ? x : x.response.data).toString() : '',
          noticeWorkId: this.isEdit ? this.current.noticeWorkId : ''
        }
        this.submitting = true
        let { code, msg } = this.isEdit ? await notice.updateNoticeWork(payload) : await notice.addNoticeWork(payload)
        this.submitting = false
        if (code === 0) {
          this.$message.success(this.isEdit ? '修改成功' : '发布成功')
          this.$emit('update:visible', false)
          this.$emit('submitted')
        } else {
          this.$message.error(msg || '提交失败')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
